<template>
  <div class="index">
    <div class="box1">
      <charts-1 :data_x='data_x' :data_y='data_y' ref="chart1"></charts-1>
      <div class="bottom_line">
        <div class="bottom_line_left"><img src="../../../public/img/IndexValuation/down.png" alt="" />{{chart1_data_down}}</div>
        <div class="bottom_line_content">
          <div class="bottom_line_content_line1" :style="{'width':line1_width}"></div>
          <div class="bottom_line_content_line2" :style="{'width':line2_width}"></div>
          <div class="bottom_line_content_line3" :style="{'width':line3_width}"></div>
        </div>
        <div class="bottom_line_right">{{chart1_data_up}}<img src="../../../public/img/IndexValuation/up.png" alt="" /></div>
      </div>
    </div>
    <div class="box2">
      <div class="box6_top_button">
        <div class="box6_top_button_option1">
          <div class="box6_top_button_text1" :class="{ box6_top_button_text2: bxjj_navigation6 == 0 }" @click="change_top_button6(0)">北向资金</div>
          <div class="box6_top_button_text1" :class="{ box6_top_button_text2: bxjj_navigation6 == 1 }" @click="change_top_button6(1)">南向资金</div>
        </div>
        <div>
          <i style="font-style: normal;float: right;font-size: 16px;color: #666;font-weight: normal;cursor: pointer;">查看更多
          <img style="width: 8px; height: 14px" src="../../../public/img/IndexValuation/right_la.png"/></i>
        </div>
      </div>

      <div class="box1_top_button" style="margin-bottom: 20px">
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 0 }" @click="change_top_button(0)">今日</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 1 }" @click="change_top_button(1)">历史每日</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation == 2 }" @click="change_top_button(2)">历史每周</div>
      </div>
      <div class="box1_top_legend_box" v-if="bxjj_navigation == 1 || bxjj_navigation == 2">
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option1_colordiv"></div>净流入金额</div>
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option2_colordiv"></div>净流出金额</div>
      </div>
      <div class="box1_top_legend_box" v-if="bxjj_navigation == 0 && bxjj_navigation6 == 0">
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option3_colordiv"></div>沪股通</div>
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option4_colordiv"></div>深股通</div>
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option5_colordiv"></div>合计净买入</div>
      </div>
      <div class="box1_top_legend_box" v-if="bxjj_navigation == 0 && bxjj_navigation6 == 1">
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option3_colordiv"></div>港股通(沪)</div>
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option4_colordiv"></div>港股通(深)</div>
        <div class="box1_top_legend_box_option1"><div class="box1_top_legend_box_option5_colordiv"></div>南向资金</div>
      </div>
      <charts-2 v-if="bxjj_navigation == 1 || bxjj_navigation == 2" ref="chart2" :chart2_data_x="chart2_data_x" :chart2_data_y="chart2_data_y"></charts-2>
      <charts-7 v-if="bxjj_navigation == 0 && bxjj_navigation6 == 1" ref="chart7" :chart7_data_x='chart7_data_x' :chart7_data_y='chart7_data_y' :chart7_data_y2='chart7_data_y2' :chart7_data_y3='chart7_data_y3'></charts-7>
      <charts-3 v-if="bxjj_navigation == 0 && bxjj_navigation6 == 0" ref="chart3" :chart3_data_x='chart3_data_x' :chart3_data_y='chart3_data_y' :chart3_data_y2='chart3_data_y2' :chart3_data_y3='chart3_data_y3'></charts-3>
    </div>
    <div class="box3">
      <div class="box1_top_title">指数估值</div>
      <div class="box1_top_button">
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation2 == 0 }"
          @click="change_top_button2(0)"
        >
          沪深
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation2 == 1 }"
          @click="change_top_button2(1)"
        >
          一级行业
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation2 == 2 }"
          @click="change_top_button2(2)"
        >
          二级行业
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation2 == 3 }"
          @click="change_top_button2(3)"
        >
          三级行业
        </div>
      </div>
      <table-1></table-1>
    </div>
    <div class="box4">
      <div class="box4_lilter_box" @click="goto_indexInfo(item)" v-for="(item,index) in recommendindexlist.slice(0,4)" :key="'1'+index">
        <div class="box4_lilter_box_top">
          <div class="box4_lilter_box_top_left">{{item.name}}</div>
          <div class="box4_lilter_box_top_right">
            <div class="box4_lilter_box_top_right_text1">{{item.latest}}</div>
            <div class="box4_lilter_box_top_right_text2">{{item.change_ratio}}%</div>
          </div>
        </div>
        <div class="box4_lilter_box_bottom">
          <charts-4 v-if="index == 0"></charts-4>
          <charts-42 v-if="index == 1"></charts-42>
          <charts-43 v-if="index == 2"></charts-43>
          <charts-44 v-if="index == 3"></charts-44>
        </div>
      </div>
    </div>
    <div class="box5">
      <div class="box1_top_title">
        热门板块
        <i style="font-style: normal;float: right;font-size: 16px;color: #666;font-weight: normal;cursor: pointer;">查看更多
        <img style="width: 8px; height: 14px" src="../../../public/img/IndexValuation/right_la.png"/></i>
      </div>
      <div class="box1_top_button" style="margin-top: 27px">
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation3 == 0 }" @click="change_top_button3(0)">行业</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation3 == 1 }" @click="change_top_button3(1)">概念</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation3 == 2 }" @click="change_top_button3(2)">地区</div>
        <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation3 == 3 }" @click="change_top_button3(3)">风格</div>
      </div>
      <div class="box1_top_bottom" v-if="hotPlatelist.length > 0">
        <div class="box1_top_bottom_box1" v-for="(item,index) in hotPlatelist.slice(0,4)" :key="'2' + index">
          <div class="box1_top_bottom_box1_title">
            <div class="box1_top_bottom_box1_title_text1">{{item.name}}</div>
            <div class="box1_top_bottom_box1_title_text2">{{item.change_ratio}}%</div>
          </div>
          <div class="box1_top_bottom_box1_content">
            <div class="box1_top_bottom_box1_content_green box1_top_bottom_box1_content_green2" style="width: 30%">
              <div class="box1_top_bottom_box1_content_text1">3</div>
            </div>
            <div class="box1_top_bottom_box1_content_black box1_top_bottom_box1_content_black2 box1_top_bottom_box1_content_black3" style="width: 10%">
              <div class="box1_top_bottom_box1_content_text2">1</div>
            </div>
            <div class=" box1_top_bottom_box1_content_red box1_top_bottom_box1_content_red2" style="width: 60%">
              <div class="box1_top_bottom_box1_content_text3">6</div>
            </div>
          </div>
          <div class="box1_top_bottom_box1_bottom">
            <div class="box1_top_bottom_box1_bottom_line1">
              <div class="box1_top_bottom_box1_bottom_line1_text1">思考乐教育</div>
              <div class="box1_top_bottom_box1_bottom_line1_text2">+20.00%</div>
            </div>
            <div class="box1_top_bottom_box1_bottom_line1">
              <div class="box1_top_bottom_box1_bottom_line1_text1">卓越教育集团</div>
              <div class="box1_top_bottom_box1_bottom_line1_text2">+11.11%</div>
            </div>
            <div class="box1_top_bottom_box1_bottom_line1">
              <div class="box1_top_bottom_box1_bottom_line1_text1">新东方-S</div>
              <div class="box1_top_bottom_box1_bottom_line1_text2">+8.61%</div>
            </div>
            <div class="box1_top_bottom_box1_bottom_line1">
              <div class="box1_top_bottom_box1_bottom_line1_text1">光正教育</div>
              <div class="box1_top_bottom_box1_bottom_line1_text2">+5.88%</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="text-align: center; height: 273px">
        <img src="../../../public/img/shares_Info/null.png" style="vertical-align: middle; width: 223px; margin-top: 50px"/>
        <div style="height: 15px;font-size: 14px;line-height: 15px;color: #999999;margin-top: 15px;">暂无数据</div>
      </div>
    </div>
    <div class="box6">
      <div class="box6_top_button">
        <div
          class="box6_top_button_text1"
          :class="{ box6_top_button_text2: bxjj_navigation4 == 0 }"
          @click="change_top_button4(0)"
        >
          融资买入
        </div>
        <div
          class="box6_top_button_text1"
          :class="{ box6_top_button_text2: bxjj_navigation4 == 1 }"
          @click="change_top_button4(1)"
        >
          融券卖出
        </div>
      </div>
      <div class="box1_top_legend_box" style="">
        <div class="box1_top_legend_box_option1">
          <div class="box1_top_legend_box_option3_colordiv"></div>
          A股融券卖出持股比例
          <i style="font-style: normal; color: red">&nbsp; 2.21%</i>
        </div>
        <div class="box1_top_legend_box_option1">
          <div class="box1_top_legend_box_option4_colordiv"></div>
          沪深全A收盘点位
          <i style="font-style: normal; color: red">&nbsp; 5727.72</i>
        </div>
      </div>
      <charts-5></charts-5>
    </div>
    <div class="box7">
      <div class="box1_top_title">热门板块</div>
      <div class="box1_top_button" style="margin-top: 27px">
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }"
          @click="change_top_button5(0)"
        >
          国家队
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }"
          @click="change_top_button5(1)"
        >
          保险
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }"
          @click="change_top_button5(2)"
        >
          基金
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 3 }"
          @click="change_top_button5(3)"
        >
          QFII
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 4 }"
          @click="change_top_button5(4)"
        >
          社保
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 5 }"
          @click="change_top_button5(5)"
        >
          券商
        </div>
        <div
          class="box1_top_button_button1"
          :class="{ box1_top_button_button2: bxjj_navigation5 == 6 }"
          @click="change_top_button5(6)"
        >
          信托
        </div>
      </div>
      <div class="box1_top_legend_box" style="">
        <div class="box1_top_legend_box_option1">
          <div class="box1_top_legend_box_option3_colordiv"></div>
          A股融券卖出持股比例
          <i style="font-style: normal; color: red">&nbsp; 2.21%</i>
        </div>
        <div class="box1_top_legend_box_option1">
          <div class="box1_top_legend_box_option4_colordiv"></div>
          沪深全A收盘点位
          <i style="font-style: normal; color: red">&nbsp; 5727.72</i>
        </div>
      </div>
      <charts-6></charts-6>
    </div>
    <!-- <div style="height:60px"></div> -->
  </div>
</template>
<script>
import {marketOverview,recommendIndex,hotPlate,northMoney,southMoney,northHistoryDay,northHistoryWeek} from '../../http/index.js'
import charts1 from "./chart/chart1.vue";
import charts2 from "./chart/chart2.vue";
import charts3 from "./chart/chart3.vue";
import charts4 from "./chart/chart4.vue";
import charts42 from "./chart/chart42.vue";
import charts43 from "./chart/chart43.vue";
import charts44 from "./chart/chart44.vue";
import charts5 from "./chart/chart5.vue";
import charts6 from "./chart/chart6.vue";
import charts7 from "./chart/chart7.vue";
import table1 from "./table/table1.vue";
export default {
  components: {
    charts1,
    charts2,
    charts3,
    charts4,
    charts42,
    charts43,
    charts44,
    charts5,
    charts6,
    charts7,
    table1,
  },
  computed:{
    line1_width(){
      let a = ((this.chart1_data_up + this.chart1_data_down ) / this.chart1_data_up) * 100
      return `${a}%`
    },
    line2_width(){
      return '5%'
    },
    line3_width(){
      let a = ((this.chart1_data_up + this.chart1_data_down ) / this.chart1_data_down) * 100
      return `${a}%`
    }
  },
  data() {
    return {
      bxjj_navigation: 0,
      bxjj_navigation2: 0,
      bxjj_navigation3: 0,
      bxjj_navigation4: 0,
      bxjj_navigation5: 0,
      bxjj_navigation6: 0,
      chart1list:[],          //市场总览 列表
      data_x:[],              //市场总览  x轴数据
      data_y:[],              //市场总览  y轴数据
      chart1_data_up:'',      //up股票数量
      chart1_data_down:'',    //down股票数量
      recommendindexlist:[],  //推荐指数
      hotPlatelist:[],        //热门板块列表
      chart3_data_x:[],        //北向资金（今日）x轴数据
      chart3_data_y:[],        //北向资金（今日） y轴数据1
      chart3_data_y2:[],        //北向资金（今日） y轴数据2
      chart3_data_y3:[],        //北向资金（今日） y轴数据3
      chart7_data_x:[],        //南向资金（今日）x轴数据
      chart7_data_y:[],        //南向资金（今日） y轴数据1
      chart7_data_y2:[],        //南向资金（今日） y轴数据2
      chart7_data_y3:[],        //南向资金（今日） y轴数据3
      chart2_data_x:[],          //北向资金 历史每日 x轴数据
      chart2_data_y:[],           //北向资金 历史每日 y轴数据
    };
  },
  methods: {
    change_top_button(e) {
      this.bxjj_navigation = e;
      this.initnorthMoney()
    },
    change_top_button2(e) {
      this.bxjj_navigation2 = e;
    },
    change_top_button3(e) {
      this.bxjj_navigation3 = e;
      this.inithotPlate()
    },
    change_top_button4(e) {
      this.bxjj_navigation4 = e;
    },
    change_top_button5(e) {
      this.bxjj_navigation5 = e;
    },
    change_top_button6(e) {
      this.bxjj_navigation6 = e;
      this.initnorthMoney()
    },
    goto_indexInfo(e){
      let codes = e.codes
      let canshu = Object.assign({},{codes})
      let codes2 = canshu.codes.slice(0,6)
      let codes3 = canshu.codes.slice(7)
      let canshu2 = `${codes3}${codes2}.html`
      this.$router.push({path:`/zhishu/${canshu2}`})
    },
    initchart1(){
      marketOverview().then((res)=>{
        this.chart1list = res.data.list
        this.chart1_data_down = res.data.down_limit_total
        this.chart1_data_up = res.data.upper_limit_total
        this.data_x = []
        this.data_y = []
        this.chart1list.map((ele,index)=>{
          this.data_x.push(ele.txt)
          if(index <5){
            this.data_y.push({
                value: ele.total,
                itemStyle: {
                color: "#3cbb73",
              }}
            )
          }else if(index == 5){
            this.data_y.push({
                value: ele.total,
                itemStyle: {
                color: "#afafaf",
              }}
            )
          }else{
            this.data_y.push({
                value: ele.total,
                itemStyle: {
                color: "#fd4c4c",
              }}
            )
          }
          return ele
        })
        setTimeout(() => {
          this.$refs.chart1.myEcharts()
        });
      }).catch((err)=>{
        console.log(err);
      })
    },
    initrecommendindex(){
      recommendIndex().then((res)=>{
        this.recommendindexlist = res.data
      }).catch((err)=>{
        console.log(err);
      })
    },
    inithotPlate(){
      let type
      if(this.bxjj_navigation3 == 0){
        type = '行业'
      }else if(this.bxjj_navigation3 == 1){
        type = '概念'
      }else if(this.bxjj_navigation3 == 2){
        type = '地区'
      }else if(this.bxjj_navigation3 == 3){
        type = '风格'
      }
      hotPlate({type}).then((res)=>{
        this.hotPlatelist = res.data.list
      }).catch((err)=>{
        console.log(err);
      })
    },
    initnorthMoney(){
      if(this.bxjj_navigation6 == 0 && this.bxjj_navigation == 0){
        northMoney().then((res)=>{
          this.chart3_data_x = []
          this.chart3_data_y = []
          this.chart3_data_y2 = []
          this.chart3_data_y3 = []
          res.data.list.map((ele,index)=>{
            this.chart3_data_x.push(ele.hour_minute)
            this.chart3_data_y.push(parseFloat(ele.bxzj_net_buy))
            this.chart3_data_y2.push(parseFloat(ele.hgt_net_buy))
            this.chart3_data_y3.push(parseFloat(ele.sgt_net_buy))
            return ele
          })
          setTimeout(() => {
            this.$refs.chart3.myEcharts3() 
          });
        }).catch((err)=>{
          console.log(err);
        })
      }else if(this.bxjj_navigation6 == 1 && this.bxjj_navigation == 0){
        southMoney().then((res)=>{
          console.log(res);
          this.chart7_data_x = []
          this.chart7_data_y = []
          this.chart7_data_y2 = []
          this.chart7_data_y3 = []
          res.data.list.map((ele,index)=>{
            this.chart7_data_x.push(ele.hour_minute)
            this.chart7_data_y.push(parseFloat(ele.ggt_h_net_buy))
            this.chart7_data_y2.push(parseFloat(ele.ggt_s_net_buy))
            this.chart7_data_y3.push(parseFloat(ele.nxzj_net_buy))
            return ele
          })
          setTimeout(() => {
            this.$refs.chart7.myEcharts7() 
          });
        }).catch((err)=>{
          console.log(err);
        })
      }else if(this.bxjj_navigation6 == 0 && this.bxjj_navigation == 1){
        let type = '北向资金'
        northHistoryDay({type}).then((res)=>{
          this.chart2_data_x = []
          this.chart2_data_y = []
          res.data.list.map((ele,index)=>{
            this.chart2_data_x.push(ele.trade_date)
            if(ele.net_inflow_amount > 0){
              this.chart2_data_y.push({
                value:ele.net_inflow_amount,
                itemStyle:{
                  color:"#fd4c4c"
                }
              })
            }else{
              this.chart2_data_y.push({
                value:ele.net_inflow_amount,
                itemStyle:{
                  color:"#3cbb73"
                }
              })
            }
            return ele
          })
          setTimeout(() => {
            this.$refs.chart2.myEcharts2()
          });
        }).catch((err)=>{
          console.log(err);
        })
      }else if(this.bxjj_navigation6 == 1 && this.bxjj_navigation == 1){
        let type = '南向资金'
        northHistoryDay({type}).then((res)=>{
          this.chart2_data_x = []
          this.chart2_data_y = []
          res.data.list.map((ele,index)=>{
            this.chart2_data_x.push(ele.trade_date)
            if(ele.net_inflow_amount > 0){
              this.chart2_data_y.push({
                value:ele.net_inflow_amount,
                itemStyle:{
                  color:"#fd4c4c"
                }
              })
            }else{
              this.chart2_data_y.push({
                value:ele.net_inflow_amount,
                itemStyle:{
                  color:"#3cbb73"
                }
              })
            }
            return ele
          })
          setTimeout(() => {
            this.$refs.chart2.myEcharts2()
          });
        }).catch((err)=>{
          console.log(err);
        })
      }else if(this.bxjj_navigation6 == 0 && this.bxjj_navigation == 2){
        let type = '北向资金'
        northHistoryWeek({type}).then((res)=>{
          let data = res.data.list.map((ele)=>{
            let a = new Date(ele.trade_date)
            let b = a.getTime() / 1000
            ele.month_day = b
            ele.net_inflow_amount = ele.net_inflow_amount
            return ele
          })
          let a = res.data.list[0].trade_date
          let _a = res.data.list[res.data.list.length - 1].trade_date
          let start_time = new Date(a)
          let _start_time = start_time.getTime() / 1000
          let week_name = []
          let week_value = []
          let _end_time = new Date(_a)
          let _end_week_num = _end_time.getTime() /1000
          let week_num = Math.floor((_end_week_num - _start_time) / 604800)
          for (let index = 1; index <= week_num; index++) {
            let time = _start_time + ((index - 1)*604800)
            let end_time = _start_time + (index * 604800)
            let a = data.filter((ele)=>{
              return ele.month_day >= time && ele.month_day < end_time
            })
            if(!a[0]){
              continue
            }
            week_name.push(a[0].trade_date)
            let b = 0
            a.forEach(element => {
              b += Number(element.net_inflow_amount)
            });
            week_value.push(b.toFixed(2))
          }

          this.chart2_data_x = week_name
          this.chart2_data_y = week_value.map((ele,index)=>{
            if(ele > 0){
              ele = {
                value:ele,
                itemStyle:{
                  color:"#fd4c4c"
                }
              }
            }else{
              ele = {
                value:ele,
                itemStyle:{
                  color:"#3cbb73"
                }
              }
            }
            return ele
          })
          setTimeout(() => {
            this.$refs.chart2.myEcharts2()
          });
        }).catch((err)=>{
          console.log(err);
        })
      }else if(this.bxjj_navigation6 == 1 && this.bxjj_navigation == 2){
        let type = '南向资金'
        northHistoryWeek({type}).then((res)=>{
          let data = res.data.list.map((ele)=>{
            let a = new Date(ele.trade_date)
            let b = a.getTime() / 1000
            ele.month_day = b
            ele.net_inflow_amount = ele.net_inflow_amount
            return ele
          })
          let a = res.data.list[0].trade_date
          let _a = res.data.list[res.data.list.length - 1].trade_date
          let start_time = new Date(a)
          let _start_time = start_time.getTime() / 1000
          let week_name = []    //x轴数据
          let week_value = []    //y轴数据
          let _end_time = new Date(_a)
          let _end_week_num = _end_time.getTime() /1000
          let week_num = Math.floor((_end_week_num - _start_time) / 604800)
          for (let index = 1; index <= week_num; index++) {
            let time = _start_time + ((index - 1)*604800)
            let end_time = _start_time + (index * 604800)
            let a = data.filter((ele)=>{
              return ele.month_day >= time && ele.month_day < end_time
            })
            if(!a[0]){
              continue
            }
            week_name.push(a[0].trade_date)
            let b = 0
            a.forEach(element => {
              b += Number(element.net_inflow_amount)
            });
            week_value.push(b.toFixed(2))
          }

          this.chart2_data_x = week_name
          this.chart2_data_y = week_value.map((ele,index)=>{
            if(ele > 0){
              ele = {
                value:ele,
                itemStyle:{
                  color:"#fd4c4c"
                }
              }
            }else{
              ele = {
                value:ele,
                itemStyle:{
                  color:"#3cbb73"
                }
              }
            }
            return ele
          })
          setTimeout(() => {
            this.$refs.chart2.myEcharts2()
          });
        }).catch((err)=>{
          console.log(err);
        })
      }
    },
  },
  mounted(){
    this.initchart1()
    this.initrecommendindex()
    this.inithotPlate()
    this.initnorthMoney()
  }
};
</script>

<style scoped>
.index {
  width: 100%;
  height: 100%;
}
.box1 {
  width: calc(100% - 48px);
  height: 288px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.box2 {
  width: calc(100% - 48px);
  height: 374px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.box3 {
  width: calc(100% - 48px);
  min-width: 1427px;
  height: 586px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.box4 {
  width: calc(100%);
  height: 222px;
  /* background-color: #ffffff; */
  border-radius: 6px;
  margin-bottom: 24px;
  /* padding: 24px; */
  display: flex;
  justify-content: space-between;
}
.box5 {
  width: calc(100% - 48px);
  height: 376px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.box6 {
  width: calc(100% - 48px);
  height: 376px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.box7 {
  width: calc(100% - 48px);
  height: 468px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 24px;
}
.bottom_line_content {
  width: 1250px;
  height: 6px;
  display: flex;
  margin-top: 7.5px;
}
.bottom_line_content_line1 {
  width: 45%;
  background-color: #3cbb73;
  position: relative;
  border-radius: 3px 0 0 3px;
}
.bottom_line_content_line1:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}
.bottom_line_content_line2 {
  width: 4%;
  background-color: #565656;
  margin: 0 3px;
  transform: skewX(-30deg);
}
.bottom_line_content_line3 {
  width: 51%;
  background-color: #e83744;
  position: relative;
  border-radius: 0px 3px 3px 0px;
}
.bottom_line_content_line3:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}
.bottom_line {
  display: flex;
  align-content: center;
  justify-content: space-around;
  font-size: 14px;
  /* color: #47ba74; */
  margin-top: 15px;
}
.bottom_line_left {
  color: #47ba74;
  min-width: 51px;
}
.bottom_line_left img {
  margin-right: 6px;
}
.bottom_line_right {
  color: #e83744;
  min-width: 51px;
}
.bottom_line_right img {
  margin-left: 6px;
}
.box1_top_title {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
.box1_top_button {
  display: flex;
  align-content: center;
  /* width: 205px; */
  margin-top: 20px;
  margin-bottom: 25px;
}
.box1_top_button_button1 {
  /* width: 72px;
  height: 30px; */
  padding: 6px 10px;
  text-align: center;
  /* line-height: 30px; */
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box1_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box1_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box1_top_text {
  font-size: 14px;

  color: #333333;
  margin-top: 20px;
}
.box4_lilter_box {
  width: 311px;
  height: 178px;
  background-color: #ffffff;
  border-radius: 3px;
  padding: 22px;
}
.box4_lilter_box_top {
  display: flex;
  justify-content: space-between;
  text-align: right;
}
.box4_lilter_box_top_left {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.box4_lilter_box_top_right_text1 {
  font-size: 18px;
  color: #fd4c4c;
}
.box4_lilter_box_top_right_text2 {
  font-size: 14px;
  color: #fd4c4c;
}
.box4_lilter_box_bottom {
  height: calc(100% - 44px);
}
.box1_top_bottom {
  width: 100%;
  height: 218px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-top: 2px;
  padding: 12px 0;
}
.box1_top_bottom_box1 {
  width: 300px;
  height: 170px;
  background-color: #ffffff;
  box-shadow: 0px 4px 16px 2px rgba(152, 152, 152, 0.13);
  border-radius: 3px;
  padding: 24px;
  /* background-color: red; */
}
.box1_top_bottom_box1_title {
  display: flex;
  justify-content: space-between;
}
.box1_top_bottom_box1_title_text1 {
  font-size: 18px;
  color: #000000;
}
.box1_top_bottom_box1_title_text2 {
  font-size: 18px;
  color: #fd4c4c;
}
.box1_top_bottom_box1_content {
  width: 100%;
  height: 6px;
  display: flex;
  margin-top: 30px;
  margin-bottom: 20px;
}
.box1_top_bottom_box1_content_green {
  background-color: #47ba74;
  height: 6px;
  position: relative;
  border-radius: 3px 0 0 3px;
}
.box1_top_bottom_box1_content_black {
  background-color: #565656;
  height: 6px;
  position: relative;
  margin: 0 3px;
  position: relative;
}
.box1_top_bottom_box1_content_black2::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}
.box1_top_bottom_box1_content_black3::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}
.box1_top_bottom_box1_content_red {
  background-color: #e83744;
  height: 6px;
  position: relative;
  border-radius: 0 3px 3px 0;
}
.box1_top_bottom_box1_content_green2:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}

.box1_top_bottom_box1_content_red2:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -2px;
  width: 6px;
  height: 6px;
  background: #fff;
  transform: skewX(-30deg);
}
.box1_top_bottom_box1_content_text1 {
  font-size: 12px;
  color: #47ba74;
  position: absolute;
  top: -17px;
  left: 0;
}
.box1_top_bottom_box1_content_text2 {
  font-size: 12px;
  color: #565656;
  position: absolute;
  top: -17px;
}
.box1_top_bottom_box1_content_text3 {
  font-size: 12px;
  color: #e83744;
  position: absolute;
  top: -17px;
  right: 0;
}
.box1_top_bottom_box1_bottom_line1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.box1_top_bottom_box1_bottom_line1_text1 {
  font-size: 14px;
  color: #000000;
}
.box1_top_bottom_box1_bottom_line1_text2 {
  font-size: 14px;
  color: #fd4c4c;
}
.box6_top_button {
  display: flex;
  margin-bottom: 25px;
  justify-content: space-between;
}
.box6_top_button_option1 {
  display: flex;
}
.box6_top_button_text1 {
  font-size: 18px;
  color: #666666;
  cursor: pointer;
}
.box6_top_button_text1:nth-child(2) {
  margin-left: 24px;
}
.box6_top_button_text2 {
  color: #000000;
  font-weight: bold;
  position: relative;
}
.box6_top_button_text2::after {
  content: " ";
  display: block;
  width: 36px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -6px;
  left: calc(50% - 18px);
}
.box1_top_legend_box {
  display: flex;
}
.box1_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box1_top_legend_box_option2 {
  display: flex;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box1_top_legend_box_option1_colordiv {
  background-color: #fd4c4c;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box1_top_legend_box_option2_colordiv {
  background-color: #3cbb73;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box1_top_legend_box_option3_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box1_top_legend_box_option4_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box1_top_legend_box_option5_colordiv {
  background-color: #ffdea8;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.border_radius_left {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.border_radius_right {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>

